import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from "ngx-toastr";

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(private toastr: ToastrService,private translate:TranslateService) {

  }

  showSuccess(message, title = "", timeOut = 5000) {
    this.toastr.clear();
    setTimeout(() => {
      this.toastr.success(title, message, { timeOut: timeOut, progressBar: false, closeButton: true});
    }, 250);
  }

  showInfo(message, title = "", timeOut = 5000) {
    this.toastr.clear();
    setTimeout(() => {
      this.toastr.info(title, message, { timeOut: timeOut, progressBar: false, closeButton: true});
    }, 250);
  }

  showError(message, title = "", timeOut = 5000) {
    this.toastr.clear();
    setTimeout(() => {
      this.toastr.error(title, message, { timeOut: timeOut, progressBar: false, closeButton: true});
    }, 250);
  }

  showWarning(message, title = "", timeOut = 5000) {
    this.toastr.clear();
    setTimeout(() => {
      this.toastr.warning(title, message, { timeOut: timeOut, progressBar: false, closeButton: true });
    }, 350);
  }

  showWarningForExpiredAccount(message, title) {
    this.toastr.clear();
    setTimeout(() => {
      this.toastr.warning(title, message, { closeButton: true, disableTimeOut: true });
    }, 350);
  }
}
